var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{attrs:{"id":"box"}},[_c('div',{attrs:{"id":"marquee"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticStyle:{"display":"none","margin-top":"-5px"},attrs:{"id":"copy"}})]),_vm._v(" "),_c('div',{attrs:{"id":"node"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e3668f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/manager/Scroller.vue
// module id = null
// module chunks = 